import { ChangeDetectorRef, Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { ContentService } from '../../../spartacus/services/content.service';
import { HttpClient } from '@angular/common/http';
import { DownloadFileService } from '../../../spartacus/services/download-file.service';
import { UserInfoService } from '../../../spartacus/services/user-info.service';
import { filter, Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-custom-detailedpage',
    templateUrl: './custom-detailedpage.component.html',
    styleUrls: ['./custom-detailedpage.component.scss'],
    standalone: false
})
export class CustomDetailedpageComponent {
  componentdata: any;
  accessresourcedata: any;
  currentRoute: string = "";
  accessResources: any;
  finalArray: any;
  selectedpdfurl: any= [];
  // selectedpdfurl = [""];
  // @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef;
  
// private readonly staticBrightcoveVideoUrl =
// 'https://players.brightcove.net/1752604059001/ByZN9ymFZ_default/index.html?videoId=5045678907001';

  constructor(private cmsService: CmsService,
    protected config: OccConfig,
    public bannerComponent: CmsComponentData<CmsBannerComponent>,
    private contentservice: ContentService,
    private router: Router,
    private http: HttpClient,
    private downloadservice: DownloadFileService,
    private userInfoService: UserInfoService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef) {
  }
  userLoggedIn: boolean = false;
  userInfo: any;
  webEnabled: any;
  subscription = new Subscription();
  isVideoModalOpen = false;
  safeVideoUrl: SafeResourceUrl | null = null;

  
  ngOnInit(): void {
    this.subscription.add(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => {
          this.getDetailPageData();
        })
    );
    this.getDetailPageData();
  }

  private getDetailPageData() {
    //for splitting the url
    let url = this.router.url.split('/');
    this.currentRoute = url[url.length - 1];
    //to retrive the  flex component page content
    this.contentservice.getdetailedcomponentsdata(this.currentRoute).subscribe((res: any) => {
      this.componentdata = res;
      //to retrieve acess resources
      this.accessresourcedata = res.additionalResourceList;
      this.contentservice.getDetailedAccessResources(this.accessresourcedata).subscribe((data: any) => {
        this.finalArray = data.results;
        this.cd.detectChanges();
      });
    });
    this.userInfoService.userLoggedIn$.subscribe(res => {
      this.userLoggedIn = res;
      if (this.userLoggedIn) {
        // this.userInfoService.getUserData().subscribe(res=>{
        //   console.log(res);
        // if(res){
        //   this.userInfo=res;
        //   this.cd.detectChanges();
        //   }
        // });
        this.webEnabled = localStorage.getItem('webEnabled');

      }

    });
    if (this.userInfo?.webEnabled == false) {
      this.renderer.setStyle(document.querySelector('.SideContent'), 'display', 'none');
    }
    this.cd.detectChanges();
  }


  // playVideo() {
  //   this.videoPlayer.nativeElement.play();
  // }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
  getpdf(pdf: any): string {
    return this.config.backend?.occ?.baseUrl + pdf.url;
  }
  pdfDownload(url: string): void {

    this.downloadservice.downloadFile(url)
      .subscribe(response => {
        let fileName = 'detailed.pdf';
        let blob: Blob = response.body as Blob;
        let a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        a.target = '_blank';
        a.click();
      },
      );
  }

  onHeaderMediaClick(event: Event): void {
    event.preventDefault();
    if (this.componentdata?.headerDownloadLabel === 'Coming Soon') {
      return;
    }  
    // If text3content exists -> open video modal
    if (this.componentdata?.text3content?.trim()) {
      const videoUrl = this.componentdata?.text3content + '&autoplay=true&muted=true'; 
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
      this.isVideoModalOpen = true;
      document.body.classList.add('video-modal-open');
    } else {
      // Existing download/open media behavior
      if (this.componentdata?.headerDownloadMedia) {
        window.open(
          this.getpdf(this.componentdata.headerDownloadMedia),
          '_blank'
        );
      }
    }
  }
  
  closeVideoModal(): void {
    this.safeVideoUrl = null;   // destroy iframe
    this.isVideoModalOpen = false;
  
    document.body.classList.remove('video-modal-open');
  }

  @HostListener('document:keydown.escape')
onEscPress(): void {
  if (this.isVideoModalOpen) {
    this.closeVideoModal();
  }
}

  downloadselectedpdf(event: Event, url: string) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedpdfurl.push(url);
    } else {
      var index = this.selectedpdfurl.indexOf(url);
      this.selectedpdfurl.splice(index, 1);
    }
  }

  
  downloadpdfs() {
    // const link=document.createElement('a');
    // link.href= this.selectedpdfurl;
    // link.click();

    if (this.selectedpdfurl.length > 0) {
      // for (let i = 0; i < this.selectedpdfurl.length; i++) {
      //   window.open(this.selectedpdfurl[i], '_blank');
      // }
      this.selectedpdfurl.forEach((url: any) => {       
        window.open(url, '_blank');     
      });
    }
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    document.body.classList.remove('video-modal-open');
  }



  // downloadSelected() {
  //   const checkboxes = document.querySelectorAll('.download-list__item input[type="checkbox"]:checked');
  //   checkboxes.forEach(checkbox => {
  //     const link = document.createElement('a');
  //     link.href = checkbox.name; // Assuming the name attribute contains the URL of the PDF
  //     link.download = ''; // You can set a filename if needed
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   });
  // }
}
